import script from "./MyprofileUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./MyprofileUpdate.vue?vue&type=style&index=0&id=15847a1a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15847a1a"]])

export default __exports__